export default __webpack_public_path__ + "static/Plots0038-22205416218f3dc1c5355884e3a8ab9c.jpg";